<template>
    <div>
        <nav class="ppv2-flex ppv2-items-center ppv2-space-x-2" aria-label="Breadcrumb">
            <span v-for="(item, index) in breadcrumbItems" :key="index" class="style_text">
                <!-- Si lien -->
                <a v-if="item.href" :href="item.href" class="text-blue-600 hover:underline" v-html="item.label"></a>
                <!-- Sinon texte simple -->
                <span v-else>{{ item.label }}</span>
            </span>
        </nav>
    </div>
</template>
<script>
export default {
    props: ['breadcrumbItems'],
}
</script>
<style scoped>
.style_text {
    font-family: 'Poppins SemiBold', sans-serif;
    font-size: 21px;
    line-height: 20px;
    letter-spacing: 0%;
    vertical-align: middle;
    color: #021832;
}
</style>
